import React from 'react';
import {DataItem, DateInput} from 'src/design-system';
import * as Yup from 'yup';
import {Text} from 'react-native';
import {Typography} from 'src/styles';
import moment from 'moment';
import {IDeveloperField} from 'dromo-uploader-react';

interface DisplayProps {
  value: string;
}

interface Props {
  valueKey: string;
}

export const Import = (
  key: string = 'birthDate',
  prefix?: string,
): IDeveloperField => ({
  label: (prefix ? prefix + ' ' : '') + 'Birth Date (MM/DD/YYYY)',
  key,
  validators: [
    {
      validate: 'regex_match',
      regex:
        '(0[1-9]|1[012])[- \\/.](0[1-9]|[12][0-9]|3[01])[- \\/.](19|20)\\d\\d$',
      errorMessage: 'Must be a valid date.',
    },
  ],
});

const resolveDisplayValue = (value: string) => {
  return moment(value).format('ll');
};

const BirthDateDisplay = ({value}: DisplayProps) => {
  return (
    <DataItem>
      <Text style={[Typography.H6]}>Birth Date</Text>
      <Text style={[Typography.P3]}>{resolveDisplayValue(value)}</Text>
    </DataItem>
  );
};

const BirthDateInput = ({valueKey}: Props) => {
  return (
    <DateInput
      valueKey={(valueKey ? valueKey + '.' : '') + 'birthDate'}
      name={'Birth Date'}
      required={true}
      maximumDate={new Date()}
    />
  );
};

export const validation = () => Yup.string().required('Birth date is required');

export const Display = BirthDateDisplay;
export const Input = BirthDateInput;
export const Value = resolveDisplayValue;

export default BirthDateInput;
